import { useState } from "react";

import { formatMarketBias, formatRiskLevel } from "../utils/marketLabels";

function buildTickerText(marketBias, strategy) {
  const bias = marketBias?.bias ? formatMarketBias(marketBias.bias) : "Market bias loading";
  const risk = marketBias?.riskLevel ? formatRiskLevel(marketBias.riskLevel) : "Risk loading";
  const plan = strategy?.primaryStrategy ?? "Strategy pending";
  const mode = strategy?.mode ?? "Mode pending";

  return `Market Bias: ${bias} | Risk: ${risk} | Active Plan: ${plan} | Mode: ${mode}`;
}

export default function Header({ activePage, loading, marketBias, strategy, onNavigate }) {
  const [profileOpen, setProfileOpen] = useState(false);
  const tickerText = buildTickerText(marketBias, strategy);
  const activePlan = strategy?.primaryStrategy ?? "Strategy pending";
  const profileInitial = "M";

  const openEventConfig = () => {
    setProfileOpen(false);
    onNavigate("config");
  };

  const openMarketBiasCalculator = () => {
    setProfileOpen(false);
    onNavigate("marketBiasCalculator");
  };

  return (
    <header className="desk-header-wrap">
      <div className="desk-header">
        <div className="desk-brand">
          <strong>MiRa Market Labs</strong>
          <span>{activePlan}</span>
        </div>
        <div className="header-actions">
          <nav className="desk-nav" aria-label="Desk sections">
            <button
              className={activePage === "desk" ? "nav-btn active" : "nav-btn"}
              type="button"
              onClick={() => onNavigate("desk")}
            >
              Market Desk
            </button>
            <button
              className={activePage === "list" ? "nav-btn active" : "nav-btn"}
              type="button"
              onClick={() => onNavigate("list")}
            >
              Opportunities
            </button>
            <button
              className={activePage === "guide" ? "nav-btn active" : "nav-btn"}
              type="button"
              onClick={() => onNavigate("guide")}
            >
              Signal Lab
            </button>
          </nav>
          <div className="profile-menu-wrap">
            <button
              className={activePage === "config" || activePage === "marketBiasCalculator" ? "profile-avatar-btn active" : "profile-avatar-btn"}
              type="button"
              aria-label="Profile"
              aria-expanded={profileOpen}
              aria-haspopup="menu"
              onClick={() => setProfileOpen((open) => !open)}
            >
              {profileInitial}
            </button>
            {profileOpen && (
              <div className="profile-menu" role="menu">
                <span>Profile Config</span>
                <button type="button" role="menuitem" onClick={openEventConfig}>
                  Event Config
                </button>
                <button type="button" role="menuitem" onClick={openMarketBiasCalculator}>
                  Market Bias Calculator
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="market-ticker" aria-label="Market and strategy highlights">
        <div className="market-ticker-track">
          <span>{tickerText}</span>
          <span>{tickerText}</span>
        </div>
      </div>
    </header>
  );
}
